// extracted by mini-css-extract-plugin
module.exports = {"story_banner":"StoryBanner_story_banner__W2x8B","story_mobilebanner":"StoryBanner_story_mobilebanner__McPrB"};